import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './case-manager.css';
import Incident from '../incident-details/incident';
import LoadingSpinner from '../loadspinner/loadspinner';
import { intruderinfo_url } from '../apis';

function CaseManagerData(props) {
  const { searchTerm } = props;
  const [caseManagerData, setCaseManagerData] = useState([]);
  const [emptyData, setEmptyData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableSize, setTableSize] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [end_date, setEnd_date] = useState(new Date().toJSON().slice(0, 10).toString());
  const [start_date, setStart_date] = useState(new Date(new Date().setMonth(new Date().getMonth() - 4)).toJSON().slice(0, 10).toString());
  const [selectedIncident, setSelectedIncident] = useState(null);

  const tableHeaders = [
    'Session Id',
    'User Id',
    'DateTime',
    'Incident Origination',
    'Risk Score(%)',
    'Risk Level',
    'Channel Source',
    'Source OS',
    'False Positive',
    'User Location',
  ];

  const tableSizeList = [5, 10, 15, 20];

  const handleIncidentClick = (row) => {
    setSelectedIncident(row);
    props.onIncidentClick(row);
  };

  const onPageChange = (newPage) => {
    setPage(newPage);
  };
  const getCurrentUserToken = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    return currentUser.token || '';
  }

  var userToken = getCurrentUserToken();
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${userToken}`
  }

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const params = `&start_date=${props.selected1 == null ? start_date : props.selected1}&end_date=${props.selected2 == null ? end_date : props.selected2}`;
        const response = await axios.get(intruderinfo_url + params, { headers });
        const result = response.data;
        const tableData = result.case_manager_data.filter(item => item.user_type === "no");
        setCaseManagerData(tableData.sort((a, b) => {
          const c = +new Date(a.date);
          const d = +new Date(b.date);
          return d - c;
        }));
        setCount(tableData.length);
        setLoading(false);
        setEmptyData(false);
      } catch (error) {
        if (error.response && error.response.data.message === "No record found") {
          setEmptyData(true);
        }
        if (error.response && error.response.data.msg === "Token has expired") {
          props.onLogout('token');
        }
        setLoading(false);
      }
    };
    getData();
  }, [props.selected1, props.selected2]);

  function filterName(searchTerm) {
    const filterData = caseManagerData.filter(profile =>
      profile.user_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return filterData;
  }

  return (
    <div>
      {selectedIncident ? (
        <Incident selectedIncident={selectedIncident} />
      ) : (
        <>
          {loading ? (<LoadingSpinner />) : ( emptyData ? <div className="empty-data" style={{ height: "400px" }}><span>No Results Found</span></div> :
            <div className="main_case">
              <div className="table_case">
                <table >
                  <thead className="tablehead">
                    <tr>
                      {tableHeaders.map((header, index) => (
                        <th key={index}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {searchTerm ? filterName(searchTerm).slice((page - 1) * tableSize, page * tableSize).map((row, index) => (
                        <tr key={index}>
                        <td className="incidentID" onClick={() => handleIncidentClick(row)}>{row.id}</td>

                        <td>{row.user_name}</td>
                        <td>
                          {new Date(row.date).toLocaleString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            second: 'numeric',
                            hour12: true,
                            timeZone: 'Asia/Kolkata',
                          })}
                        </td>
                        <td>{row.incidence_origination}</td>
                        <td>{row.request_risk_score ?? 'NA'}</td>
                        <td>{row.risk_level}</td>
                        <td>{row.channel_source}</td>
                        <td>{row.user_source_os}</td>
                        <td>{row.false_positive}</td>
                        <td>{row.user_location}</td>
                      </tr>
                    )) :
                      caseManagerData.slice((page - 1) * tableSize, page * tableSize).map((row, index) => (
                        <tr key={index}>
                          <td className="incidentID" onClick={() => handleIncidentClick(row)}>{row.id}</td>

                          <td>{row.user_name}</td>
                          <td>
                            {new Date(row.date).toLocaleString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric',
                              hour: 'numeric',
                              minute: 'numeric',
                              second: 'numeric',
                              hour12: true,
                              timeZone: 'Asia/Kolkata',
                            })}
                          </td>
                          <td>{row.incidence_origination}</td>
                          <td>{row.request_risk_score ?? 'NA'}</td>
                          <td>{row.risk_level}</td>
                          <td>{row.channel_source}</td>
                          <td>{row.user_source_os}</td>
                          <td>{row.false_positive}</td>
                          <td>{row.user_location}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="paginator">
                <div className="itemSize">
                  <label htmlFor="tableSize">Items per page:</label>
                  <select
                    name="tableSize"
                    id="tableSize"
                    value={tableSize}
                    onChange={(e) => setTableSize(parseInt(e.target.value))}>
                    {tableSizeList.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="itemValue">
                  <span>
                    {searchTerm
                      ? `${tableSize * (page - 1) + 1}-${Math.min(tableSize * page, filterName(searchTerm).length)} of ${filterName(searchTerm).length}`
                      : `${tableSize * (page - 1) + 1}-${Math.min(tableSize * page, count)} of ${count}`}
                  </span>
                </div>
                <div className="item">
                  <button
                    className="previous"
                    onClick={() => onPageChange(page - 1)}
                    disabled={page === 1}>
                    Previous
                  </button>
                  <button
                    className="next"
                    onClick={() => onPageChange(page + 1)}
                    disabled={page === Math.ceil(count / tableSize)}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default CaseManagerData;

